import { Col, DatePicker, Form, Input, message, Modal, Row, Select, Switch, Upload } from "antd";
import dayjs from "dayjs";
import { useContext, useEffect, useState } from "react";
import { addExpense, getAllExpenseType } from "../../utils/API";
import axios from "axios";
import { AuthContext } from "../../Auth/AuthContext";

interface AddExpenseProps {
    visible: boolean;
    onClose: () => void;
    onTaskCreated: () => void;
}

interface ExpenseFormValues {
    _id: string;
    name: string;
    date: string;
    amount: number;
    expense: string;
    expense_type: string;
    description: string;
    authorize: boolean;
}

const AddExpenseModel: React.FC<AddExpenseProps> = ({
    visible,
    onClose,
    onTaskCreated,
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [form] = Form.useForm();
    const { authData } = useContext(AuthContext);
    const [types, setTypes] = useState<any>([]);

    const role_id = authData.roleId;

    const handleCancel = () => {
        form.resetFields();
        onClose();
    }

    const onFinish = async (values: ExpenseFormValues) => {
        setIsLoading(true);
        try {
            const formData = new FormData();


            const finalValues = {
                ...values,
            };


            Object.entries(finalValues).forEach(([key, value]) => {
                if (key === 'date' && value && typeof value === 'object' && 'format' in value) {
                    formData.append(key, (value as any).format('DD-MM-YYYY'));
                } else if (value !== undefined && value !== null) {
                    formData.append(key, value.toString());
                }
            });

            await addExpense(formData);
            message.success('Expense submitted successfully!');
            handleCancel();
            onTaskCreated();
        } catch (error) {
            console.error('Error submitting Expense:', error);
            if (axios.isAxiosError(error)) {
                message.error(error.response?.data?.message || 'An error occurred.');
            } else {
                message.error('An unexpected error occurred.');
            }
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (visible) {
            form.setFieldsValue({
                authorize: role_id.roleId === 1 ? true : false  // if admin → true
            });
        }
    }, [visible]);

    useEffect(() => {
        const fetchTypes = async () => {
            setIsLoading(true);
            try {
                const response: any = await getAllExpenseType();
                console.log("Types:", response);
                if (response?.expenseType) {
                    setTypes(response.expenseType);
                }
            } catch (error) {
                console.error("Error fetching expense type:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchTypes();
    }, []);

    return (
        <Modal
            visible={visible}
            onCancel={onClose}
            footer={null}
            width={800}
            centered={true}
            destroyOnClose
            className="custom-modal"
            bodyStyle={{
                overflowY: "auto",
                fontFamily: "inter, sans-serif",
            }}
            style={{
                bottom: 20,
                top: 20,
                // maxHeight: 'calc(100vh - 30px)',
                margin: '0 auto',
                position: 'relative',
            }}
            styles={{
                header: {
                    padding: "12px",
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#f1f5ffff",
                },
                content: {
                    padding: 0,
                    overflow: "hidden",
                },
            }}
            title={
                <div
                    style={{
                        color: "#4b5563",
                        fontFamily: "inter, sans-serif",
                        fontSize: "20px",
                        fontWeight: 500,
                    }}
                >
                    Add Expense
                </div>
            }
        >
            <Form onFinish={onFinish} form={form} layout="horizontal"
                labelCol={{ span: 5 }}
                wrapperCol={{ span: 19 }}
                colon={false} style={{ margin: 0 }}>
                <div className="elements">
                    <Form.Item
                        label={
                            <span style={{
                                color: '#4b5563',
                                fontFamily: 'inter, sans-serif',
                                fontSize: '14px',
                                paddingLeft: "15px",
                                fontWeight: 500,
                            }}>
                                Full Name <span className="text-red-500">*</span>
                            </span>
                        }
                        name="name"
                        required={false}
                        rules={[{ required: true, message: "Please enter the name" }]}
                    >
                        <Input placeholder="Fullname" className="Allinput" />
                    </Form.Item>

                    <Form.Item
                        initialValue={dayjs()}
                        label={
                            <span style={{
                                color: '#4b5563',
                                fontFamily: 'inter, sans-serif',
                                fontSize: '14px',
                                paddingLeft: "15px",
                                fontWeight: 500,
                            }}>
                                Date
                            </span>
                        }
                        name="date"
                        required={false}
                    >
                        <DatePicker className="Allinput" format="DD-MM-YYYY" style={{ width: '100%' }} />
                    </Form.Item>

                    <Form.Item
                        label={
                            <span style={{
                                color: '#4b5563',
                                fontFamily: 'inter, sans-serif',
                                fontSize: '14px',
                                paddingLeft: "15px",
                                fontWeight: 500,
                            }}>
                                Amount
                            </span>
                        }
                        name="amount"
                        required={false}
                    >
                        <Input placeholder="Amount" className="Allinput" />
                    </Form.Item>

                    <Form.Item
                        name="expense"
                        initialValue="Bank"
                        label={
                            <span style={{
                                color: '#4b5563',
                                fontFamily: 'inter, sans-serif',
                                fontSize: '14px',
                                paddingLeft: "15px",
                                fontWeight: 500,
                            }}>
                                Expense
                            </span>
                        }
                        required={false}
                    >
                        <Select
                            placeholder="Select Mode of Expense"
                            className="CustomSelect"
                            showSearch
                            optionFilterProp="children"
                            // value={position}
                            onChange={(value) => {
                                // setPosition(value);
                                form.setFieldsValue({ technology: undefined });
                            }}
                        >
                            <Select.Option value="Bank">Bank</Select.Option>
                            <Select.Option value="Cash">Cash</Select.Option>
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="expense_type"
                        label={
                            <span style={{
                                color: '#4b5563',
                                fontFamily: 'inter, sans-serif',
                                fontSize: '14px',
                                paddingLeft: "15px",
                                fontWeight: 500,
                            }}>
                                Expense Type
                            </span>
                        }
                        required={false}
                    >
                        <Select
                            placeholder="Select Expense Type"
                            className="CustomSelect"
                            showSearch
                            optionFilterProp="children"
                            // value={position}
                            onChange={(value) => {
                                // setPosition(value);
                                // form.setFieldsValue({ technology: undefined });
                            }}
                        >
                            {types.map((type: any) => (
                                <Select.Option key={type._id} value={type.expense_type}>
                                    {type.expense_type}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="authorize"
                        required={false}
                        label={
                            <span style={{
                                color: '#4b5563',
                                fontFamily: 'inter, sans-serif',
                                fontSize: '14px',
                                paddingLeft: "15px",
                                fontWeight: 500,
                            }}>
                                Authorized?
                            </span>
                        }
                        valuePropName="checked"
                    >
                        <Switch checkedChildren="Yes" unCheckedChildren="No" />
                    </Form.Item>

                    <Form.Item
                        label={
                            <span style={{
                                color: '#4b5563',
                                fontFamily: 'inter, sans-serif',
                                fontSize: '14px',
                                paddingLeft: "15px",
                                fontWeight: 500,
                            }}>
                                Description
                            </span>
                        }
                        name="description"
                        required={false}
                    >
                        <Input.TextArea
                            placeholder="Enter description"
                            className="Allinputtextarea"
                        />
                    </Form.Item>
                </div>
                <Row justify="end">
                    <Col
                        xs={24}
                        sm={24}
                        md={24}
                        xl={24}
                        xxl={20}
                        className="d-flex justify-content-end me-4"
                    >
                        <div className="button-wrapper">
                            <button
                                className="allcanclebutton"
                                onClick={onClose}
                                type="button"
                                disabled={isLoading}
                            >
                                Cancel
                            </button>
                            <button
                                className="allsubmitebutton w-20"
                                type="submit"
                                disabled={isLoading}
                            >
                                {isLoading ? 'Adding...' : 'Add'}
                            </button>
                        </div>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default AddExpenseModel;